import { useMemo, useState } from "react";
import { useEstimateEditorSettings, useEstimateEditorStore } from "@tools";
import { useEditorWebsocket } from "@hooks";

export const useVersioning = () => {
  
  const {
    readOnly,
    allowInteractions,
    hasEditorPrivileges,
    isProposal,
    isPresetEditor,
    isLocked,
    forceAllowVersionSelect,
  } = useEstimateEditorSettings();
  const editorStore = useEstimateEditorStore();
  const socket = useEditorWebsocket();
  
  const [isDragged, setDragged] = useState(false);
  
  const {
    estimateVersions,
    visibleEstimateVersions,
    sortedVersions,
    visibilityMode,
    isArchived,
  } = editorStore;
  
  const handleVersionReorder = async (list, key) => {
    // setDragged(false);
    socket?.requestVersionReorder(key, list.map(({ id }, index) => ({ key: id, order: index + 1 })));
    editorStore.reorderVersions(list.map(({ id }) => id));
  };
  
  const editable = (!readOnly || isLocked) && hasEditorPrivileges && !isArchived && !isPresetEditor;
  const clickable = !isPresetEditor && (hasEditorPrivileges || allowInteractions);
  const removable = editable && estimateVersions?.length > 1;
  const hideable = editable && visibleEstimateVersions > 1;
  
  const versions = useMemo(() => (
    isProposal || (!hasEditorPrivileges && !visibilityMode && !forceAllowVersionSelect)
      ? sortedVersions.filter(({ visible }) => visible)
      : sortedVersions
  ), [isProposal, hasEditorPrivileges, sortedVersions, visibilityMode, forceAllowVersionSelect]);
  
  
  return {
    versions,
    editable,
    clickable,
    removable,
    hideable,
    isDragged,
    setDragged,
    handleVersionReorder,
  }
  
}